const generateDocumentObject = () => ({
  bundles: [],
  doc_types: [],
});

export default generateDocumentObject;
